/* Per-card "Choose ..." CTAs on the bundle variant cards (D2 product page).
 *
 * Each CTA adds its specific variant to the cart through the main product
 * form, so Dawn's <product-form> AJAX handler runs unchanged and opens the
 * cart drawer (D4 drawer + cross-sell behaviour intact).
 *
 * A single delegated listener is used because Dawn's product-info.js swaps
 * the whole <variant-selects> subtree (cards included) on variant change,
 * which would orphan per-button listeners.
 */
(function () {
  if (window.shwinkVariantCardCtaBound) return;
  window.shwinkVariantCardCtaBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.variant-cards__cta');
    if (!button || button.disabled) return;

    var form = document.getElementById(button.dataset.productFormId);
    if (!form) return;

    // Sync the card's radio first so Dawn updates gallery, price, description
    // box and the ?variant= URL to match what was just added.
    var radio = document.getElementById(button.dataset.inputId);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Set the submitted variant id explicitly — don't wait for Dawn's async
    // section re-render to update the hidden input.
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = button.dataset.variantId;
      idInput.disabled = false;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });
})();
